import React, {Component} from "react"
import {Route, Switch} from "react-router"
import {get} from "lodash"

import {NestedRoute, withPartialRoute} from "@irati/utils/history/routing"
import AppContainer from "@irati/ui/src/AppContainer"
import mainTheme from "@irati/ui/src/global/theme"
import {injectIntl, InjectIntl, LangLoader} from "@irati/utils/lang"
import authentication from "@irati/auth"
import {Payment} from "@irati/types"
import Deals from "@irati-web/perks/src/containers/Deals"
import DealInfo from "@irati-web/perks/src/containers/DealInfo"
import {WALLET, PERKS} from "@irati-web/app/src/routeConfig"

import UserWalletContainer from "../containers/Wallet"
import RewardWalletContainer from "../containers/Reward/Reward"
import TenantWalletContainer from "../containers/Tenant/Tenant"
import CardPaymentFormContainer from "../containers/Tenant/CardPaymentForm"
import {ConfirmTenantWalletTopUpPage} from "../components/Tenant/CardPaymentForm"
import TenantWalletTransferContainer from "../containers/Tenant/Transfer"
import TenantWalletRefundContainer from "../containers/Tenant/Refund"
import SendCreditContainer from "../containers/SendCredit"

import AdminRewardWalletContainer from "../containers/AdminReward/AdminRewardWallet"
import AdminRewardTopUpContainer from "../containers/AdminReward/AdminRewardTopUp"
import DistributeRewardContainer from "../containers/AdminReward/DistributeReward"
import NewRewardWallet from "../containers/Tenant/NewRewardWallet"

interface Location {
  payment: Payment
}

interface Props extends InjectIntl {
  path: string,
  location: Location
}

class Routes extends Component<Props> {
  render() {
    const {path, intl, formatMessage} = this.props
    const isI18nLoaded = !!get(intl.messages, "wallet.routes.wallet", null)
    const tenantName = authentication.userTenant().public_name
    const isCreditTopup = location.pathname.endsWith("/tenant/top-up")

    return (
      <Route
        path={path}
        render={() => (
          <LangLoader buckets={[WALLET, PERKS]}>
            <AppContainer mainBackground={isCreditTopup && mainTheme.colors.primary2}>
              <Switch>
                <NestedRoute
                  match={path}
                  exact
                  path={`${path}/reward`}
                  permissions="wallet.rewardWallet"
                  title={isI18nLoaded ? formatMessage({id: "wallet.routes.rewardWallet"}) : ""}
                  component={RewardWalletContainer} />
                <NestedRoute
                  match={path}
                  exact
                  path={`${path}/tenant`}
                  permissions="wallet.tenantWallet"
                  title={isI18nLoaded ? formatMessage({id: "wallet.routes.tenantWallet"}, {tenantName}) : ""}
                  component={TenantWalletContainer} />
                <NestedRoute
                  match={path}
                  exact
                  path={`${path}/tenant/top-up`}
                  permissions="wallet.tenantWallet"
                  title={isI18nLoaded ? formatMessage({id: "wallet.routes.tenantWalletTopUp"}) : ""}
                  component={NewRewardWallet} />
                <NestedRoute
                  match={path}
                  exact
                  path={`${path}/tenant/top-up/confirm/:tenantWalletTopupId`}
                  permissions="wallet.tenantWallet"
                  title={isI18nLoaded ? formatMessage({id: "wallet.routes.tenantWalletCardPayment"}) : ""}
                  component={ConfirmTenantWalletTopUpPage} />
                <NestedRoute
                  match={path}
                  exact
                  path={`${path}/tenant/card-payment`}
                  permissions="wallet.tenantWallet"
                  title={isI18nLoaded ? formatMessage({id: "wallet.routes.tenantWalletCardPayment"}) : ""}
                  component={CardPaymentFormContainer} />
                <NestedRoute
                  match={path}
                  exact
                  path={`${path}/tenant/transfer`}
                  permissions="wallet.tenantWallet"
                  title={isI18nLoaded ? formatMessage({id: "wallet.routes.tenantWalletTransfer"}) : ""}
                  component={TenantWalletTransferContainer} />
                <NestedRoute
                  match={path}
                  exact
                  path={`${path}/tenant/refund`}
                  permissions="wallet.tenantWallet"
                  title={isI18nLoaded ? formatMessage({id: "wallet.routes.tenantWalletRefund"}) : ""}
                  component={TenantWalletRefundContainer} />
                <NestedRoute
                  match={path}
                  exact
                  path={`${path}/send-credit`} // User GBP to User GBP
                  permissions="wallet"
                  title={isI18nLoaded ? formatMessage({id: "wallet.routes.sendCredit"}) : ""}
                  component={SendCreditContainer} />

                <NestedRoute
                  match={path}
                  path={`${path}/flexi-checkout`}
                  permissions="wallet.flexiRewards.canRewardEmployees"
                  title={isI18nLoaded ? formatMessage({id: "wallet.routes.wallet"}) : ""}
                  component={AdminRewardTopUpContainer} />
                <NestedRoute
                  match={path}
                  exact
                  path={`${path}/flexi-reward`}
                  permissions="wallet.flexiRewards.canRewardEmployees"
                  title={isI18nLoaded ? formatMessage({id: "wallet.routes.wallet"}) : ""}
                  component={AdminRewardWalletContainer} />
                <NestedRoute
                  match={path}
                  path={`${path}/flexi-assign`}
                  permissions="wallet.flexiRewards.canRewardEmployees"
                  title={isI18nLoaded ? formatMessage({id: "wallet.routes.wallet"}) : ""}
                  component={DistributeRewardContainer} />
                <NestedRoute
                  match={path}
                  exact
                  path={`${path}/flexi-reward/categories/:category?`}
                  permissions="wallet.flexiRewards.canRewardEmployees"
                  title={isI18nLoaded ? formatMessage({id: "wallet.routes.wallet"}) : ""}
                  component={Deals} />
                <NestedRoute
                  match={path}
                  exact
                  path={`${path}/flexi-reward/info/:urlSlug`}
                  permissions="wallet.flexiRewards.canRewardEmployees"
                  title={isI18nLoaded ? formatMessage({id: "wallet.routes.wallet"}) : ""}
                  component={DealInfo} />
                <NestedRoute
                  match={path}
                  permissions="wallet"
                  title={isI18nLoaded ? formatMessage({id: "wallet.routes.wallet"}) : ""}
                  component={UserWalletContainer} />
              </Switch>
            </AppContainer>
          </LangLoader>
        )} />
    )
  }
}

export default withPartialRoute(injectIntl(Routes))
